import { BranchUrlParameters } from '../domain/branch'
import jwtDecode from 'jwt-decode'
import { UserIdentity, UserSession } from '../domain/identity'
import { UserExistsError } from './error.service'

export const userAlreadyCreated =
  'Already found an entry for the provided username.'

export const storeToken = (key: 'jwt' | 'accessToken', token: string): void =>
  localStorage.setItem(key, token)

export const getJwt = (): string | null => localStorage.getItem('jwt')

export const getAccessToken = (): string | null =>
  localStorage.getItem('accessToken')

const clearStorage = (): void => localStorage.clear()

export const conditionallyClearStorage = (): void => {
  // Save this data parsed from Branch links
  const promo_code = localStorage.getItem(BranchUrlParameters.PROMO_CODE)
  const referral_code = localStorage.getItem(BranchUrlParameters.REFERRAL_CODE)

  clearStorage()

  promo_code && localStorage.setItem(BranchUrlParameters.PROMO_CODE, promo_code)
  referral_code &&
    localStorage.setItem(BranchUrlParameters.REFERRAL_CODE, referral_code)
}

export const jwtBearHeader = ():
  | { Authorization: string }
  | Record<string, never> => {
  const jwt = getJwt()

  return jwt ? { Authorization: `Bearer ${jwt}` } : {}
}

export const accessTokenHeader = ():
  | { 'x-paceline-access-token': string }
  | Record<string, never> => {
  const accessToken = getAccessToken()

  return accessToken ? { 'x-paceline-access-token': `${accessToken}` } : {}
}

export const timeZoneOffsetHeader = (): {
  'x-paceline-time-offset': string
} => {
  const offsetInMins = new Date().getTimezoneOffset()
  const offsetInHrs = offsetInMins / 60
  const headerValue =
    offsetInHrs > 0 ? `-${offsetInHrs}:00` : `+${Math.abs(offsetInHrs)}:00`
  return { 'x-paceline-time-offset': `${headerValue}` }
}

export const storeTokensForUser = (data: UserSession): void => {
  const { sessionToken, accessToken, error } = data
  if (error) {
    if (error == userAlreadyCreated)
      throw new UserExistsError(userAlreadyCreated)
    else throw new Error(error)
  }
  storeToken('jwt', sessionToken)
  storeToken('accessToken', accessToken)
}

export const getUserIdentityFromJwt = (): UserIdentity | null => {
  const token = getJwt()
  if (token) {
    return jwtDecode<UserIdentity>(token)
  }
  return null
}
